import { AssetMetadata } from "../models/Model3D";
import { AssetElement } from "./AssetElement";

export type SubModelElementsProps = {
  metadatas: AssetMetadata[];
}

export const AssetElements = (props: SubModelElementsProps) => {
  const { metadatas } = props;

  return <>
    {metadatas.map(assetMetadata => <AssetElement metadata={assetMetadata} key={`asset-element-${assetMetadata.name}`} />)}
  </>
}
